import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import AdminAuditLog from '../components/AdminAuditLog';

const AdminAuditLogPage: React.FC = () => {
  const { userRole } = useAuth();

  if (userRole !== 'admin') {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">
          <i className="fas fa-exclamation-triangle me-2"></i>
          Access denied. Admin privileges required.
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h1>
                <i className="fas fa-history me-2 text-primary"></i>
                Admin Audit Log
              </h1>
              <p className="text-muted mb-0">
                Complete history of administrative actions and role modifications
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <AdminAuditLog maxEntries={200} showTitle={false} />
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-12">
          <div className="card bg-light">
            <div className="card-body">
              <h6 className="card-title">
                <i className="fas fa-info-circle me-2"></i>
                About Audit Logging
              </h6>
              <p className="card-text small text-muted mb-2">
                This audit log tracks all administrative actions performed in the system, including:
              </p>
              <ul className="small text-muted mb-0">
                <li><strong>Admin Role Management:</strong> Invitations sent, accepted, rejected, and role relinquishments</li>
                <li><strong>User Account Management:</strong> Account locking and unlocking actions</li>
                <li><strong>System Configuration:</strong> Changes to system settings and configuration</li>
                <li><strong>Security Events:</strong> Important security-related administrative actions</li>
              </ul>
              <p className="card-text small text-muted mt-2 mb-0">
                All entries include timestamps, the admin who performed the action, and relevant details.
                This log is essential for security auditing and compliance purposes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminAuditLogPage;
